import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import { urlBackNestApp } from '../routes/urls';

const crsCatalog = 'crs/catalog';
const registry = 'registry';

const Domain = {
  getBackendUrl: async (domain: string) => {
    const path = `${urlBackNestApp}/domain/backend-url?frontend-domain=${domain}`;
    const args: RequestInit = { method: 'GET' };
    const response = await fetch(path, args);
    return response.json();
  },
};

const Catalog = {
  getCatalogByCode: (code: any) => apiClient.get<any>(`${crsCatalog}/?code=${code}`),
  getAll: () => apiClient.get<any>(`${crsCatalog}/all`),
  create: (data: any) => apiClient.post<any, any>(`${crsCatalog}`, data),
  update: (id: number | string, data: any) => apiClient.put<any, any>(`${crsCatalog}/${id}`, data),
  delete: (id: number | string) => apiClient.delete<any, any>(`${crsCatalog}/${id}`),
};

const Registry = {
  getRegistries: (params: any) => apiClient.get<any>(`${registry}?${new URLSearchParams(params).toString()}`),
  create: (data: any) => apiClient.post<any, any>(`${registry}`, data),
  update: (id: string, data: any) => apiClient.patch(`${registry}/${id}`, data),
};

export const HttpAgent = {
  Catalog,
  Registry,
  Domain
};

export default HttpAgent;
